import { IBriefResource } from "../../briefs";
import { IClassroomResource } from "../../classrooms";
import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, OneOrManyFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { WorkStatus } from "../../works";
import { IGroupSpaceList } from "../types";

export interface IGroupSpaceListQueryParameters
    extends IPaginateable, IOrderable<"title" | "createdAt" | "briefTitle" | "lastActivityDate" | "lastGroupWorkDate"> {
    filters?: {
        classrooms?: RelationalFilter<IClassroomResource>;
        briefs?: RelationalFilter<IBriefResource>;
        learners?: RelationalFilter<IUserResource>;
        correctedLearners?: RelationalFilter<IUserResource>;
        lastGroupWorkStatus?: OneOrManyFilter<WorkStatus>;
        briefTitle?: string | null;
        hasCorrections?: boolean;
    };
}

export type useGroupSpaceListQueryResult = IGroupSpaceList;

const mapFilters = (filters: IGroupSpaceListQueryParameters["filters"]) => {
    const { classrooms, briefs, learners, correctedLearners, lastGroupWorkStatus, briefTitle, hasCorrections } =
        filters ?? {};

    return {
        "classroom.uuid": mapRelationalFilter(classrooms),
        "brief.uuid": mapRelationalFilter(briefs),
        "learner.uuid": mapRelationalFilter(learners),
        "groupCorrections.learner.uuid": mapRelationalFilter(correctedLearners),
        lastGroupWorkStatus: lastGroupWorkStatus,
        briefTitle: briefTitle,
        hasCorrections: hasCorrections,
    };
};

export const groupSpaceListQuery: IApiQueryFunction<IGroupSpaceListQueryParameters> = ({
    pagination,
    order,
    filters,
}) => {
    return {
        method: "GET",
        url: `/group_spaces${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useGroupSpaceListQuery = createApiQueryHook<IGroupSpaceListQueryParameters, useGroupSpaceListQueryResult>(
    groupSpaceListQuery,
);
